var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24a.967.967 0 0 1-.713-.288A.968.968 0 0 1 9 23v-1h6v1c0 .283-.096.52-.287.712A.968.968 0 0 1 14 24h-4z",
    fill: "#545454"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.003 6.02a4.972 4.972 0 0 0-2.509 9.265l.492.288.003.57.003.757V18.022h4.031v-1.117l-.003-.754-.003-.576.497-.291a4.972 4.972 0 0 0-2.51-9.264zM5.031 10.99a6.972 6.972 0 1 1 10.991 5.697l.001.212V18.022a2 2 0 0 1-2 2h-4.03a2 2 0 0 1-2-2v-1.117l-.002-.211a6.964 6.964 0 0 1-2.96-5.703z",
    fill: "#545454"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.983 11.697a1 1 0 1 0 0-2v2zm-1.952 0h1.952v-2h-1.952v2zM2.033 11.697a1 1 0 1 1 0-2v2zm1.951 0H2.033v-2h1.951v2zM20.043 4.336a1 1 0 0 0-1.414-1.414l1.414 1.414zM18.63 5.75l1.414-1.414-1.414-1.414-1.414 1.414 1.414 1.414zM3.715 4.336a1 1 0 1 1 1.414-1.414L3.715 4.336zM5.129 5.75 3.715 4.336l1.414-1.414 1.414 1.414L5.129 5.75zM11 1.009a1 1 0 1 1 2 0h-2zm0 2v-2h2v2h-2z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulbIcon);
export default __webpack_public_path__ + "static/media/bulbIcon.6c54ae9a3e9555dfbbe96e6e256490d4.svg";
export { ForwardRef as ReactComponent };